
// API网关
const apiHost = 'https://apis.i-ac.cn'   //wz-api-v2.firerock.tech
const apiStage = 'RELEASE'
const apiAppKey = '203785501'
const apiAppSecret = 'erfft2ntp8pgggruv1878eesix2urqzb'

// OSS
const ossHost = 'https://fr-ac-files.oss-cn-hangzhou.aliyuncs.com'
const ossOptions = {
  region: 'oss-cn-hangzhou',
  bucket: 'wenzhong-dev',
  accessKeyId: 'LTAI5gjGh00FK3Jf',
  accessKeySecret: 'IzxGFhWFwR4iUUPQpHgy0JDphpP9wG',
  endpoint: 'https://oss-cn-hangzhou.aliyuncs.com'
}

export {
  apiHost,
  apiStage,
  apiAppKey,
  apiAppSecret,
  ossHost,
  ossOptions
}
